export const EMAIL_MARKETING_AUTOMATIONS_SUB_PAGE = 'emailMarketing_automations';
export const EMAIL_MARKETING_CRM_AUTOMATIONS_SUB_PAGE = 'emailMarketing_crm_automation';
export const EMAIL_MARKETING_ROOT_PAGE = 'emailMarketing_root';
